<template>
  <div>
    <form @submit.prevent="$emit('form-submit', form, day)">
      <div class="form-message">
        <p class="nm" v-if="goal && !fetchingGoal">
          Your current walking goal is {{ form.walkingTimeGoal }} minutes
        </p>
        
        <p class="nm" v-if="!goal && !fetchingGoal">
          ⚠️ You have not set your walking goal, please do so above.
        </p>
      </div>

      <div class="field hidden">
        <label for="walking-time-goal">
          <span>How many minutes did you hope to walk today?</span>
          <input
            type="number"
            name="walking-time-goal"
            min="0"
            v-model="form.walkingTimeGoal"
          />
        </label>
      </div>

      <div class="field">
        <label for="walking-time">
          <span>How many minutes did you walk today?</span>
          <input
            id="walking-time"
            type="number"
            name="walking-time"
            min="0"
            v-model="form.walkingTime"
            required
          />
        </label>
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Set your walking time!</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import "firebase/firestore";

export default {
  name: "Form",
  props: ["existingEntry", "day"],

  async created() {
    await this.getDB
      .collection("goals")
      .where("module", "==", "steps")
      .where("user", "==", this.getUID)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.form.walkingTimeGoal = doc.data().data.walkingTimeGoal;
          this.goal = true;
        });
      })
      .catch(() => {});

    this.fetchingGoal = false;
  },

  computed: {
    ...mapGetters(["getDB", "getUID"]),
  },

  data() {
    // Define walking time.
    const walkingTime =
      this.existingEntry &&
      this.existingEntry.data &&
      this.existingEntry.data.walkingTime
        ? this.existingEntry.data.walkingTime
        : "";

    return {
      fetchingGoal: true,
      goal: false,

      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        walkingTimeGoal: this.goal || "",
        walkingTime,
      },
    };
  },
};
</script>

<style>
[v-cloak] {
  display: none !important;
}

button {
  margin-right: 1rem;
}

.hidden {
  display: none;
}

.form-message {
  height: 19px;
  margin: 16px 0;
}

.nm {
  margin: 0;
}
</style>
